import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { BusinessTypes, Country, ImageUpload } from 'src/app/shared/models/general.models'
import { UploadImageComponent } from '../../../../shared/components/upload-image/upload-image.component'
import { OrganizationsService } from '../../services/organizations.service'
import { Subscription } from 'rxjs'
import { organizationModel } from '../../models/organizations.model'
import { environment } from 'src/environments/environment'
import { TranslateService } from '@ngx-translate/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { SharedService } from 'src/app/shared/services/shared.service'
import { Pattern } from 'src/app/shared/constants/patterns.constant'
import { ToastrService } from 'ngx-toastr'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'

@Component({
	selector: 'app-business-details-organization-info',
	templateUrl: './business-details-organization-info.component.html',
	styleUrls: ['./business-details-organization-info.component.scss'],
})
export class BusinessDetailsOrganizationInfoComponent
	implements OnInit, OnChanges, OnDestroy
{
	@Input() organizationData: organizationModel = new organizationModel()
	@Output() dataChanged: EventEmitter<any> = new EventEmitter<any>()
	logoConfig: ImageUpload = {
		imageCropDimensions: 1 / 1,
		imageWidth: 200,
		imageHeight: 200,
	}
	imgConfig: ImageUpload = {
		imageCropDimensions: 3 / 1,
		imageWidth: 1500,
		imageHeight: 500,
	}
	editMode = false
	subscription = new Subscription()
	attachmentUrl = environment.attachmentPath
	orgInfoForm : FormGroup = new FormGroup({})
	countries: Country[] = []
	businessTypes: BusinessTypes[] = []
	businessNameExist = false
	oldValues : any = null
	isChanged = false
	constructor(
		public translate: TranslateService,
		private dialog: MatDialog,
		private OrganizationService: OrganizationsService,
		private sharedServ: SharedService,
		private toaster: ToastrService
	) {}

	ngOnInit(): void {
		this.initForm()
		this.getCountries()
		this.getTypes()
	}

	ngOnChanges() {
		this.initForm()
	}

	initForm() {
		this.orgInfoForm = new FormGroup({
			countryId: new FormControl(this.organizationData?.country?.id),
			businessName: new FormControl(this.organizationData?.businessName, [
				Validators.required,
				Validators.minLength(2),
			]),
			serviceProviderTypeId: new FormControl(this.organizationData?.type?.id),
			maroofNumber: new FormControl(this.organizationData?.maroofNumber, [
				Validators.minLength(3),
				Validators.pattern(Pattern.numWithoutSpace),
			]),
			commercialRegistration: new FormControl(
				this.organizationData?.commercialRegistration,
				[Validators.minLength(10), Validators.pattern(Pattern.numWithoutSpace)]
			),
		})
		this.oldValues = this.orgInfoForm.getRawValue()

		// this.orgInfoForm.disable()
		this.subscription.add(
			this.orgInfoForm.valueChanges.subscribe(
				(res) =>
					(this.isChanged =
						JSON.stringify(this.oldValues) != JSON.stringify(res))
			)
		)
	}

	getCountries() {
		this.subscription.add(
			this.sharedServ.getCountryCode().subscribe({
				next: (res: any) => {
					this.countries = res.result
				},
			})
		)
	}

	getTypes() {
		this.subscription.add(
			this.sharedServ.getServiceProviderTypes().subscribe((res: any) => {
				this.businessTypes = res?.result
			})
		)
	}

	checkBusinessNameExist() {
		let val = this.getController('businessName')?.value
		if (val?.length > 1) {
			this.subscription.add(
				this.OrganizationService.checkBussinessName(
					this.organizationData.id,
					val
				).subscribe(
					(res: any) => {
						this.businessNameExist = false
					},
					(err: any) => {
						if (this.editMode) {
							this.businessNameExist = err?.error?.error?.message
						}
					}
				)
			)
		}
	}

	uploadImage(imageName: string) {
		this.dialog
			.open(UploadImageComponent, {
				width: '752px',
				panelClass: 'overflow-y-auto',
				data: imageName == 'logo' ? this.logoConfig : this.imgConfig,
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						const body = new FormData()
						body.append('image', res.selectedFile)
						this.subscription.add(
							this.getApi(imageName, body).subscribe((res: any) => {
								this.isChanged = true
								imageName == 'logo'
									? (this.organizationData.logoUrl = res?.result?.url)
									: imageName == 'commercial'
									? (this.organizationData.commercialRegisterationUrl =
											res?.result?.url)
									: (this.organizationData.maroofNumberUrl = res?.result?.url)
							})
						)
					}
				},
			})
	}

	getApi(name: string, body: any) {
		return name == 'logo'
			? this.OrganizationService.uploadOrganizationLogo(body)
			: name == 'commercial'
			? this.OrganizationService.UploadCommercialRegistrationImage(body)
			: this.OrganizationService.UploadMaroofImage(body)
	}

	saveChanges() {
		if (
			!this.organizationData?.hasAppointments &&
			this.organizationData?.country?.id !==
				this.orgInfoForm?.get('countryId')?.value
		) {
			this.dialog
				.open(ConfirmationMessageComponent, {
					width: '416',
					height: '360',

					data: {
						image: 'assets/images/block.svg',
						notflex: true,

						message: 'CONFIRMATION_MESSAGE.CHANGE_COUNTRY_MSG',

						cancelBtn: 'ACTIONS.CANCEL',
						confirmBtn: 'ACTIONS.CHANGE_COUNTRY',
					},
				})
				.afterClosed()
				.subscribe({
					next: (res) => {
						if (res) {
							this.updateData()
							this.editMode = false
						}
					},
				})
		} else {
			this.updateData()
			this.editMode = false
		}
		// this.updateData()
	}
	updateData() {
		const Body = {
			id: this.organizationData.id,
			logoUrl: this.organizationData?.logoUrl,
			maroofNumberUrl: this.organizationData?.maroofNumberUrl,
			commercialRegisterationUrl:
				this.organizationData?.commercialRegisterationUrl,
			countryId: this.organizationData?.country?.id,
			...this.orgInfoForm.getRawValue(),
		}
		this.subscription.add(
			this.OrganizationService.UpdateBusinessDetails(Body).subscribe((res) => {
				this.organizationData = { ...this.organizationData, ...Body }
				this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))
				this.editMode = false
				this.dataChanged.emit()
			})
		)
	}
	changeEditMode(cancel?: boolean) {
		this.editMode = !this.editMode
		if (this.organizationData?.hasAppointments) {
			this.getController('countryId')?.disable()
		}
		cancel ? this.initForm() : null
	}
	compareWith(a: any, b: any) {
		return a == b
	}
	getController(controlName: string) {
		return (this.orgInfoForm as FormGroup).controls[controlName] as FormControl
	}

	ngOnDestroy() {
		this.subscription.unsubscribe()
	}
}
